import { rootStateBranchSelector } from '../../../internal/rootStateBranchSelector';

export const highwaysSelector = rootStateBranchSelector('highways');
